module.exports = __webpack_public_path__ + "static/sinead-slideshow-03@2x-7b2e51a0904f05819dc86cae2e5b7820.jpg";